webpackJsonp([16096279806066],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Enquiry = function (_Component) {
	  _inherits(Enquiry, _Component);
	
	  function Enquiry(props) {
	    _classCallCheck(this, Enquiry);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.bindEnquiryForm = _this.bindEnquiryForm.bind(_this);
	    _this.toJSONString = _this.toJSONString.bind(_this);
	    return _this;
	  }
	
	  Enquiry.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var script = document.createElement("script");
	
	    script.async = true;
	    script.defer = true;
	    script.src = "https://cdn.emailjs.com/sdk/2.2.4/email.min.js";
	    script.addEventListener('load', function () {
	      emailjs.init("user_AIIIQH0XbtIz1mVKO8DSb");
	      _this2.bindEnquiryForm();
	    });
	
	    document.querySelector('.enquiry').appendChild(script);
	  };
	
	  Enquiry.prototype.toJSONString = function toJSONString(form) {
	    var obj = {};
	    var elements = form.querySelectorAll("input, select, textarea");
	
	    for (var i = 0; i < elements.length; ++i) {
	      var element = elements[i];
	      var name = element.name;
	      var value = element.value;
	
	      if (name) {
	        obj[name] = value;
	      }
	    }
	
	    //return JSON.stringify(obj);
	    return obj;
	  };
	
	  Enquiry.prototype.bindEnquiryForm = function bindEnquiryForm() {
	    var _this3 = this;
	
	    var myform = document.querySelector("form.enquiry");
	
	    myform.addEventListener('submit', function (event) {
	      event.preventDefault();
	
	      var params = _this3.toJSONString(myform);
	      // var params = myform.serializeArray().reduce(function(obj, item) {
	      //     obj[item.name] = item.value
	      //     return obj
	      // }, {})
	
	      // Change to your service ID, or keep using the default service
	      var service_id = "smtp_server";
	      var template_id = "template_AdZ3cqmm";
	      var button = myform.querySelector('button');
	
	      button.innerText = 'Sending...';
	      emailjs.send(service_id, template_id, params).then(function () {
	        alert("Sent!");
	        myform.reset();
	        button.innerText = 'Submit';
	      }, function (err) {
	        alert("Send email failed!\r\n Response:\n " + JSON.stringify(err));
	        button.innerText = 'Submit';
	      });
	
	      return false;
	    });
	  };
	
	  Enquiry.prototype.render = function render() {
	    return _react2.default.createElement(
	      "form",
	      { className: "enquiry", method: "post" },
	      _react2.default.createElement(
	        "div",
	        { className: "fieldset cols" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("input", { type: "text", maxLength: "100", placeholder: "Name", name: "from_name", required: true })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("input", { type: "email", maxLength: "100", placeholder: "Email", name: "from_email", required: true })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "fieldset cols" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("input", { type: "text", maxLength: "100", placeholder: "Telephone", name: "from_telephone" })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement("input", { type: "text", maxLength: "100", placeholder: "Website", name: "from_website" })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "fieldset" },
	        _react2.default.createElement("textarea", { placeholder: "Your message or project info", name: "from_message" })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "cols" },
	        _react2.default.createElement("div", null),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "button",
	            null,
	            "Submit"
	          )
	        )
	      )
	    );
	  };
	
	  return Enquiry;
	}(_react.Component);
	
	exports.default = Enquiry;
	module.exports = exports["default"];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeroBanner = function (_Component) {
	  _inherits(HeroBanner, _Component);
	
	  function HeroBanner(props) {
	    _classCallCheck(this, HeroBanner);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.createArrow = _this.createArrow.bind(_this);
	    _this.randomBounceArrow = _this.randomBounceArrow.bind(_this);
	    _this.doScrolling = _this.doScrolling.bind(_this);
	    _this.getElementY = _this.getElementY.bind(_this);
	    return _this;
	  }
	
	  HeroBanner.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var heroBanner = document.getElementById(this.props.heroId);
	    var nextSection = document.getElementById(this.props.nextId);
	    var scrollDownArrow = this.createArrow();
	
	    scrollDownArrow.addEventListener('click', this.doScrolling.bind(null, nextSection, 1500));
	    scrollDownArrow.addEventListener('animationend', function () {
	      scrollDownArrow.classList.remove('bounce');
	
	      _this2.randomBounceArrow(scrollDownArrow, 5000, 12000);
	    });
	
	    // Append to element
	    heroBanner.append(this.randomBounceArrow(scrollDownArrow, 5000, 12000));
	  };
	
	  HeroBanner.prototype.getElementY = function getElementY(query) {
	    if (typeof query == "object") return window.pageYOffset + query.getBoundingClientRect().top;else return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top;
	  };
	
	  HeroBanner.prototype.doScrolling = function doScrolling(element, duration) {
	    var startingY = window.pageYOffset;
	    var elementY = this.getElementY(element);
	    // If element is close to page's bottom then window will scroll only to some position above the element.
	    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
	    var diff = targetY - startingY;
	    // Easing function: easeInOutCubic
	    // From: https://gist.github.com/gre/1650294
	    var easing = function easing(t) {
	      return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	    };
	    var start;
	
	    if (!diff) return;
	
	    // Bootstrap our animation - it will get called right before next frame shall be rendered.
	    window.requestAnimationFrame(function step(timestamp) {
	      if (!start) start = timestamp;
	      // Elapsed miliseconds since start of scrolling.
	      var time = timestamp - start;
	      // Get percent of completion in range [0, 1].
	      var percent = Math.min(time / duration, 1);
	      // Apply the easing.
	      // It can cause bad-looking slow frames in browser performance tool, so be careful.
	      percent = easing(percent);
	
	      window.scrollTo(0, startingY + diff * percent);
	
	      // Proceed with animation as long as we wanted it to.
	      if (time < duration) {
	        window.requestAnimationFrame(step);
	      }
	    });
	  };
	
	  HeroBanner.prototype.createArrow = function createArrow() {
	    var arrowButton = document.createElement('button');
	
	    arrowButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.6 18.32"><path d="M15.78,12.56l-3-3L9.11,5.9,5.94,2.73c-.51-.52-1-1-1.54-1.54l0,0A2.35,2.35,0,0,0,2.77.5a2.3,2.3,0,0,0-1.6.67A2.26,2.26,0,0,0,.5,2.77a2.35,2.35,0,0,0,.67,1.61l1.29,1.3,3.11,3.1,3.71,3.71,3.14,3.14c.46.46.91.94,1.38,1.39a2.89,2.89,0,0,0,4,0l.12-.12.72-.72,2.82-2.82,3.68-3.68,3.35-3.36,1.86-1.85.08-.09a2.35,2.35,0,0,0,.67-1.61,2.3,2.3,0,0,0-.67-1.6A2.26,2.26,0,0,0,28.82.5a2.34,2.34,0,0,0-1.6.67h0L26,2.43l-3,3L19.27,9.11C18.22,10.16,16.83,11.51,15.78,12.56Z"/></svg>';
	    arrowButton.setAttribute('title', 'Click here or scroll down to view more');
	    arrowButton.setAttribute('class', 'more');
	
	    return arrowButton;
	  };
	
	  HeroBanner.prototype.randomBounceArrow = function randomBounceArrow(element, minTime, maxTime) {
	    setTimeout(function () {
	      element.classList.add('bounce');
	    }, Math.floor(Math.random() * maxTime + minTime));
	
	    return element;
	  };
	
	  HeroBanner.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'fs fs-more', id: this.props.heroId, 'data-next': this.props.nextId },
	      children
	    );
	  };
	
	  return HeroBanner;
	}(_react.Component);
	
	exports.default = HeroBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Map = function (_Component) {
	    _inherits(Map, _Component);
	
	    function Map(props) {
	        _classCallCheck(this, Map);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.init = _this.init.bind(_this);
	        _this.googleMap = _this.googleMap.bind(_this);
	        _this.mergeOptions = _this.mergeOptions.bind(_this);
	        return _this;
	    }
	
	    Map.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        if (!window.google) {
	            var script = document.createElement('script');
	            script.async = true;
	            script.defer = true;
	            script.src = "//maps.googleapis.com/maps/api/js?key=AIzaSyA2x3rfhmNK4DBawFUnWq4UxvttHNjkeIE";
	            script.addEventListener('load', function () {
	                _this2.init();
	            });
	
	            document.querySelector('.goo-map').appendChild(script);
	        } else this.init();
	    };
	
	    Map.prototype.init = function init() {
	        this.googleMap('.goo-map', {
	            markers: [{
	                marker: '/static/images/map-marker.svg',
	                width: 60,
	                height: 60,
	                top: 60,
	                left: 0,
	                lat: 52.5785483,
	                lng: 1.121296,
	                goo: 'dxUUp7LMXW32'
	            }]
	        });
	    };
	
	    Map.prototype.mergeOptions = function mergeOptions(userOptions, options) {
	        Object.keys(userOptions).forEach(function (key) {
	            options[key] = userOptions[key];
	        });
	    };
	
	    Map.prototype.googleMap = function googleMap(selector, userOptions) {
	        // Merge passed options with defaults
	        var element = document.querySelector(selector);
	
	        if (!element) return;
	
	        var options = {
	            lat: element.getAttribute('data-lat'),
	            lng: element.getAttribute('data-lng'),
	            goo: element.getAttribute('data-goo'),
	            zoom: element.getAttribute('data-zm') || 10,
	            markers: [],
	            width: 2560,
	            height: 1400,
	            minHeight: 200,
	            maxHeight: 760
	        };
	
	        if (userOptions) {
	            this.mergeOptions(userOptions, options);
	        }
	
	        (window.redraw = function (map, point) {
	            var vW = window.innerWidth,
	                vH = window.innerHeight,
	                rt = options.width / options.height,
	                mW = element.parentNode.clientWidth,
	                mH = Math.max(Math.min(mW / rt, options.maxHeight), options.minHeight);
	
	            //element.style.height = mH+'px';
	            element.style.height = '100%';
	
	            if (map) map.setCenter(point);
	        })();
	
	        var point = new google.maps.LatLng(options.lat, options.lng),
	            MY_MAPTYPE_ID = 'custom_style',
	            MY_COLOURS = {
	            white: '#ffffff',
	            black: '#212328',
	            dark: '#231F20',
	            mid: '#e4e4e4',
	            light: '#ededeb',
	            blue: '#cadce7',
	            green: '#c2d1c6'
	        },
	            featureOpts = [{
	            "featureType": "administrative",
	            "elementType": "labels.text.fill",
	            "stylers": [{
	                "color": "#444444"
	            }]
	        }, {
	            "featureType": "landscape",
	            "elementType": "all",
	            "stylers": [{
	                "color": "#f2f2f2"
	            }]
	        }, {
	            "featureType": "poi",
	            "elementType": "all",
	            "stylers": [{
	                "visibility": "off"
	            }]
	        }, {
	            "featureType": "road",
	            "elementType": "all",
	            "stylers": [{
	                "saturation": -100
	            }, {
	                "lightness": 45
	            }]
	        }, {
	            "featureType": "road",
	            "elementType": "geometry",
	            "stylers": [{
	                "gamma": "1.00"
	            }, {
	                "lightness": "-20"
	            }]
	        }, {
	            "featureType": "road",
	            "elementType": "all",
	            "stylers": [{
	                "visibility": "simplified"
	            }]
	        }, {
	            "featureType": "road",
	            "elementType": "labels",
	            "stylers": [{
	                "visibility": "off"
	            }]
	        }, {
	            "featureType": "transit",
	            "elementType": "all",
	            "stylers": [{
	                "visibility": "off"
	            }]
	        }, {
	            "featureType": "water",
	            "elementType": "all",
	            "stylers": [{
	                "visibility": "on"
	            }, {
	                "hue": "#ff0000"
	            }]
	        }, {
	            "featureType": "water",
	            "elementType": "geometry",
	            "stylers": [{
	                "visibility": "on"
	            }, {
	                "color": "#2e485b"
	            }, {
	                "gamma": "2"
	            }]
	        }, {
	            "featureType": "water",
	            "elementType": "labels.text",
	            "stylers": [{
	                "visibility": "on"
	            }, {
	                "color": "#ffffff"
	            }]
	        }],
	            myMapOptions = {
	            zoom: parseInt(options.zoom),
	            center: point,
	            mapTypeControl: false,
	            mapTypeId: MY_MAPTYPE_ID,
	            draggable: true,
	            scrollwheel: false,
	            zoomControl: true,
	            fullscreenControl: false,
	            zoomControlOptions: {
	                position: google.maps.ControlPosition.RIGHT_BOTTOM
	            },
	            streetViewControl: false
	        },
	            map = new google.maps.Map(element, myMapOptions),
	            customMapType = new google.maps.StyledMapType(featureOpts);
	
	        map.mapTypes.set(MY_MAPTYPE_ID, customMapType);
	
	        [].forEach.call(options.markers, function (item, index) {
	            var image = {
	                url: item.marker,
	                size: new google.maps.Size(item.width, item.height),
	                scaledSize: new google.maps.Size(item.width / 2, item.height / 2),
	                anchor: new google.maps.Point(item.left, item.top)
	            },
	                marker = new google.maps.Marker({
	                draggable: false,
	                icon: image,
	                map: map,
	                position: item.lat && item.lng ? new google.maps.LatLng(item.lat, item.lng) : point
	            });
	
	            if (item.goo) google.maps.event.addListener(marker, 'click', function () {
	                var winUrl = item.goo.indexOf('http') === 0 || item.goo.indexOf('/') === 0 ? item.goo : 'https://goo.gl/maps/' + item.goo;
	
	                window.open(winUrl, '_self');
	            });
	        });
	
	        window.addEventListener('resize', function () {
	            window.redraw(map, point);
	        });
	    };
	
	    Map.prototype.render = function render() {
	        return _react2.default.createElement('div', {
	            className: 'goo-map',
	            'data-mkr': 'google',
	            'data-lat': '52.5785483',
	            'data-lng': '1.121296',
	            'data-goo': 'kPKxccYKuY72',
	            'data-zm': '10' });
	    };
	
	    return Map;
	}(_react.Component);
	
	exports.default = Map;
	module.exports = exports['default'];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heroBanner = __webpack_require__(43);
	
	var _heroBanner2 = _interopRequireDefault(_heroBanner);
	
	var _map = __webpack_require__(204);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _enquiry = __webpack_require__(203);
	
	var _enquiry2 = _interopRequireDefault(_enquiry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Get in touch if you like my work, and interested in working together.',
	      meta: [{
	        name: 'description',
	        content: 'Like my work, and interested in working together? Get in touch so we can discuss your requirements.'
	      }]
	    }),
	    _react2.default.createElement(
	      _heroBanner2.default,
	      { heroId: 'phone-hero', nextId: 'contact' },
	      _react2.default.createElement(
	        'div',
	        { className: 'heading' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Contact me'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'contact', className: 'section white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columnar' },
	          _react2.default.createElement(
	            'header',
	            { className: 'story' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'CONTACT'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Neil Rudd',
	              _react2.default.createElement('br', null),
	              '7 Steward Close',
	              _react2.default.createElement('br', null),
	              'Wymondham',
	              _react2.default.createElement('br', null),
	              'Norfolk',
	              _react2.default.createElement('br', null),
	              'NR18 0EZ'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'EMAIL'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:hello@neilrudd.co.uk' },
	                'hello@neilrudd.co.uk'
	              )
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Telephone'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '01953 600 859'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(_enquiry2.default, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section wevet white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columnar story' },
	          _react2.default.createElement(
	            'header',
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Why Norfolk'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'article' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Boasting beautiful landscapes and historic market towns Norfolk is a great place to live and work and unlike its portrayal in the media, it is very far from being a sleepy backwater. Norfolk has a strong creative and digital presence with many leading marketing agencies having their offices in Norwich or the surrounding area and with a fast direct train line to London we are not far away from the hustle and bustle of the capital.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'wevet-bar white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(_map2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section white' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper center story' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Let\'s work together'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Like my work, and interested in working together? Get in touch so we can discuss your requirements.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\'m currently booking in projects to commence from late Sept 2018.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-me-js-39323a5a435b6d7ad552.js